import ThomasScottLogo from "@/assets/logo.png";
import Text from "@/components/common/Text";

/**
 * Neutral full-screen loading state, mirroring SignInPage's "Signing you in…"
 * pattern. Used wherever we'd otherwise render `null` and leave the user
 * staring at a blank white page.
 */
export const FullScreenLoader = ({ message = "Loading…" }: { message?: string }) => (
  <div className="flex h-screen flex-col items-center justify-center gap-6 bg-white">
    <img src={ThomasScottLogo} alt="Thomas Scott" className="h-10 w-auto" />
    <Text variant="heading_h6" className="text-shades-neutral-300">
      {message}
    </Text>
  </div>
);
